'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var TextInput = require('@narvar/nth-block-text-input');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);

const StyledReviewSummaryContainer = styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-0"
})(["padding:2rem 1.5rem;", ""], _ref => {
  let {
    theme
  } = _ref;
  return theme.bodytextDefaultNone;
});
const StyledHeaderContainer = styled__default["default"].header.withConfig({
  componentId: "sc-fksb16-1"
})(["text-align:center;"]);
const StyledMain = styled__default["default"].main.withConfig({
  componentId: "sc-fksb16-2"
})(["margin:2rem 0;"]);
const StyledItemWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-3"
})(["display:flex;justify-content:space-between;"]);
const StyledUnorderedList = styled__default["default"].ul.withConfig({
  componentId: "sc-fksb16-4"
})(["margin:0;padding:0;list-style-type:none;"]);
styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-5"
})(["display:flex;width:100%;margin:2rem 0 1rem;@media screen and (min-width:48rem){margin:2rem 0;}"]);
styled__default["default"].figure.withConfig({
  componentId: "sc-fksb16-6"
})(["width:3.5rem;margin:0;@media screen and (min-width:48rem){width:12.5rem;}"]);
styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-7"
})(["width:100%;margin:0 0 0 1rem;@media screen and (min-width:48rem){display:flex;justify-content:space-between;}"]);
styled__default["default"].ul.withConfig({
  componentId: "sc-fksb16-8"
})(["margin:0 0 1rem;padding:0;list-style-type:none;@media screen and (min-width:48rem){margin:0;}"]);
styled__default["default"].li.withConfig({
  componentId: "sc-fksb16-9"
})(["line-height:1.25rem;margin:0 0 0.25rem;"]);
const StyledDisclaimerText = styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-10"
})(["", " color:#999;margin:0.5rem auto;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return style.getFontSizing(theme.captiontextDefaultNone, {
    fontSize: '12px',
    lineHeight: '16px'
  });
});
const StyledConditionalSections = styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-11"
})(["display:flex;flex-direction:column;gap:1.5rem;"]);
const StyledAddEmailToReturn = styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-12"
})(["background:#ececec;border-radius:10px;padding:1rem;display:flex;flex-direction:column;gap:1rem;"]);
const StyledParagraph = styled__default["default"].p.withConfig({
  componentId: "sc-fksb16-13"
})(["margin:0;"]);
const StyledSavePreferences = styled__default["default"].div.withConfig({
  componentId: "sc-fksb16-14"
})(["display:flex;flex-direction:column;align-items:center;margin:2rem auto 0;max-width:640px;& > label + span{margin-top:1.5rem;}"]);
const StyledPreferencesEmail = styled__default["default"](TextInput__default["default"]).withConfig({
  componentId: "sc-fksb16-15"
})(["background-color:#fff;max-width:300px;margin-top:0.5rem;"]);

exports.StyledAddEmailToReturn = StyledAddEmailToReturn;
exports.StyledConditionalSections = StyledConditionalSections;
exports.StyledDisclaimerText = StyledDisclaimerText;
exports.StyledHeaderContainer = StyledHeaderContainer;
exports.StyledItemWrapper = StyledItemWrapper;
exports.StyledMain = StyledMain;
exports.StyledParagraph = StyledParagraph;
exports.StyledPreferencesEmail = StyledPreferencesEmail;
exports.StyledReviewSummaryContainer = StyledReviewSummaryContainer;
exports.StyledSavePreferences = StyledSavePreferences;
exports.StyledUnorderedList = StyledUnorderedList;
